<template>
  <div
    class="container__progress-line"
    :class="direction"
    :style="`height: ${customHeight}`"
  >
    <simple-svg :src="require(`@/assets/vunel_progressLine.svg`)" width="8px" />
    <div class="tick-body"></div>
  </div>
</template>

<script>
export default {
  name: 'ProgressLineVunel',
  props: {
    direction: {
      type: String,
      default: 'horizontal',
    },
    customHeight: {
      type: String,
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  &__progress-line.horizontal {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 7;
    .tick-body {
      height: 100%;
      width: 2px;
      background-color: rgb(228, 64, 59);
    }
  }

  &__progress-line.vertical {
    z-index: 7;
    height: 100%;
  }
}
</style>

<style></style>
